import { render, staticRenderFns } from "./ArnOutdatedWarning.vue?vue&type=template&id=c1fdf4e2"
import script from "./ArnOutdatedWarning.vue?vue&type=script&lang=ts"
export * from "./ArnOutdatedWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports